import { formatAsFull } from 'helpers/dateHelper';
import { getSelectedAutoLoanRefi } from 'helpers/localstorage';

export const sortAttr = {
  'Lowest Monthly Payment': 'monthlyPayment',
  'Lowest APR': 'apr',
  'Shortest term': 'term',
};

export const sortList = [
  'Lowest Monthly Payment',
  'Lowest APR',
  'Shortest term',
];

export const sortTypeString = {
  'Lowest Monthly Payment': 'Lowest Monthly Payment',
  'Lowest APR': 'Lowest APR',
  'Lowest Term': 'Lowest Term',
};

export const PURCHASE_NEW = 'PURCHASE_NEW';
export const REFINANCE = 'REFINANCE';
export const DEFAULT_LOAN_AMOUNT = 25000;
export const MIN_NEW_AUTOLOAN = 2000;
export const MAX_NEW_AUTOLOAN = 100000;
export const DEFAULT_DOWN_PAYMENT = '0';

export const buildAutoLoanQueryObject = (
  creditInfo,
  userInfo,
  extraQueryAttributes,
  isOcfPage,
) => {
  let state = userInfo?.primaryAddress?.state?.toLowerCase();
  let income = userInfo?.annualIncome;

  if (isOcfPage) {
    state = userInfo.state;
    income = userInfo.income;
  }

  let basicQuery = {
    state,
    creditScore: creditInfo.creditScore,
    income,
    itemsPerPage: 1000,
  };

  return { ...basicQuery, ...extraQueryAttributes };
};

export const buildAutoRefinanceloanDetails = (refinanceAccount, creditInfo) => {
  return {
    ...refinanceAccount,
    lastRefreshDate: formatAsFull(creditInfo?.lastRefreshDate),
    term: Math.round(
      refinanceAccount.balance / refinanceAccount.monthlyPayment,
    ),
  };
};

export const getRefinanceAccount = autoLoanAccounts => {
  if (autoLoanAccounts?.length === 1) {
    return autoLoanAccounts[0];
  } else {
    return autoLoanAccounts[getSelectedAutoLoanRefi() - 1];
  }
};

export const getFilteredAutoLoan = (autoLoans, currentSortType) => {
  return autoLoans.filter(account => {
    return account.monthlyPayment && account.apr;
  });
};

export const getFilteredAutoLoanOffers = (
  autoLoans,
  currentSortType,
  refinanceAccount,
) => {
  let genericRefinanceLoanOffers = [];
  let topRefinanceOffer;

  const filteredAutoLoans = autoLoans.filter(account => {
    if (account.monthlyPayment && account.apr) {
      return true;
    } else {
      genericRefinanceLoanOffers.push(account);
      return false;
    }
  });

  if (refinanceAccount) {
    topRefinanceOffer = filteredAutoLoans.reduce((acc, current) => {
      return current?.averagePaymentSavings < acc?.averagePaymentSavings
        ? acc
        : current;
    }, {});
  }

  return {
    autoLoanOffers: getSortedAutoLoans(filteredAutoLoans, currentSortType),
    genericRefinanceLoanOffers,
    topRefinanceOffer,
  };
};

export const getFilteredGenericAutoLoan = autoLoans => {
  return autoLoans.filter(account => {
    return !(account.monthlyPayment && account.apr);
  });
};

export const getSortedAutoLoans = (
  autoLoans,
  currentSortType = sortList[0],
) => {
  return autoLoans.sort((a, b) => {
    if (a[sortAttr[currentSortType]] === b[sortAttr[currentSortType]]) {
      return a.apr - b.apr;
    }
    return a[sortAttr[currentSortType]] - b[sortAttr[currentSortType]];
  });
};

export const PURCHASE_TYPE = 'Purchase';
export const REFINANCE_TYPE = 'Refinance';
